const push = (relativePath: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.location.href = `${window.location.origin}/${relativePath}`;
};

const routingUtils = {
  push,
};

export default routingUtils;
